import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDwightBlackLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 190,
	height: 33,
	viewBox: "0 0 190 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7687 24.3851H9.59205V8.62622H14.5572C20.2245 8.62622 22.4491 10.6311 22.4491 16.0679C22.4491 21.5048 20.2245 24.3851 14.7687 24.3851ZM15.7161 0.667969H0V21.3647L11.0638 32.3346H15.6653C25.951 32.3346 31.9397 25.532 31.9397 16.0242C31.9397 6.51628 27.169 0.667969 15.7161 0.667969Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.465 32.3346H37.4474L30.3008 0.667969H40.5138L42.7018 13.2313C43.3353 17.031 43.8591 20.3579 44.2308 23.9474H44.3406C44.8136 20.2003 45.3458 16.6545 45.9287 13.2313L48.0321 0.667969H60.3148L62.2747 13.2313C62.7984 16.6545 63.2208 20.2353 63.6432 23.9474H63.753C64.226 20.4016 64.8174 17.031 65.3918 13.2313L67.3009 0.667969H76.9818L69.7845 32.3346H56.5557L54.7564 18.8783C54.334 15.5514 53.9116 11.8043 53.5399 8.26727H53.4301C53.0077 11.7692 52.5347 15.6039 52.1123 18.8783L50.465 32.3346Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.4487 0.667969H78.6211V32.3346H88.4487V0.667969Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.1116 17.0088C90.1116 6.99291 95.5235 0.667969 106.185 0.667969C115.128 0.667969 119.633 4.76996 120.6 11.3969L111.571 13.1585C110.981 10.5329 109.75 8.81322 106.048 8.81322C101.5 8.81322 99.8325 11.6989 99.8325 17.0088C99.8325 21.958 101.542 24.7934 106.322 24.7934C111.101 24.7934 112.101 23.2247 112.101 21.4379V20.834H105.997V13.8212H121.207V31.7726H112.076V25.3051H111.973C111.058 29.298 108.433 32.3346 102.568 32.3346C94.8737 32.3346 90.0859 26.1607 90.0859 17.0088",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.846 32.3346V20.8832H132.324V32.3346H122.844V0.667969H132.324V11.9093H142.846V0.667969H152.327V32.3346H142.846Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.965 0.667969H180.172V9.6418H171.824V32.3346H162.313V9.6418H153.965V0.667969Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDwightBlackLogo);
export default ForwardRef;
